<template>
  <div>
    <page-header
      :page="headerPage"
      :actions="headerActions"
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    />
    <board class="mb-3" :details="boardDetails">
      <template #data-item="{ item }">
        <div v-if="!item.data">
          <custom-balloon
            :background-color="item.statusColor"
            :text="item.statusName"
            dot
          />
        </div>
      </template>
    </board>
    <div class="mb-4">
      <div class="row">
        <div class="col-12 px-md-0">
          <q-tab :active-tab="activeTab">
            <q-tab-item
              title="Información del Equipo"
              @click="setCurrentTab(0)"
            >
              <equipment-information :equipment="details" />
              <loan-information
                :loanReturn="returnedLoanDetails"
                :loan="loanInfo"
              />
            </q-tab-item>
            <q-tab-item
              title="Historial de Equipo"
              lazy
              @click="setCurrentTab(1)"
            >
              <equipment-history :equipment="details" />
            </q-tab-item>
            <q-tab-item title="Historial de Custodio" @click="setCurrentTab(2)">
              <custodian-history />
            </q-tab-item>
            <q-tab-item title="Historial de Bitácora" @click="setCurrentTab(3)">
              <binnacle-history :history="binnacles" />
            </q-tab-item>
          </q-tab>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from 'PageHeader';
import Board from 'Board';
import { QTab, QTabItem } from '@/components/common/q-tabs';
import mixAlert from '@/mixins/alert.mixin';
import service from '@/services/api/inventorycatalog.api';
import CustomBalloon from 'custom-balloon';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
import {
  EquipmentInformation,
  EquipmentHistory,
  CustodianHistory,
  BinnacleHistory,
} from './tabs';
import TABS from '@/utils/constants/inventoryManagementDetailTabs';

import { LoanInformation } from './components';

export default {
  name: 'InventoryMaintenanceEquipmentDetails',
  components: {
    PageHeader,
    Board,
    QTab,
    QTabItem,
    CustomBalloon,
    EquipmentInformation,
    EquipmentHistory,
    CustodianHistory,
    BinnacleHistory,
    LoanInformation,
  },
  mixins: [mixAlert],
  data: () => ({
    details: {},
    returnedLoanDetails: {},
    loanInfo: {},
    binnacles: [],
    activeTab: TABS.Information,
  }),
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    catalogId() {
      return Number(this.$route.params.id);
    },
    equipmentId() {
      return Number(this.$route.params.equipmentId);
    },
    headerPage() {
      return {
        icon: 'fas fa-laptop',
        title: `Administración Inventario: ${this.details.catalogName}`,
        routes: [
          'Inventario',
          'Mantenimiento del Catálogo de Equipos de Asistencia Tecnológica',
        ],
      };
    },
    headerActions() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => this.$router.go(-1),
        },
      ];
    },
    boardDetails() {
      return [
        [
          {
            label: 'Nombre de Equipo:',
            data: this.details.name ?? '-',
            cols: 'col-12 col-md pt-2',
          },
          {
            label: 'Código de Equipo:',
            data: this.details.code ?? '-',
            cols: 'col-12 col-md pt-2',
          },
          {
            label: 'Estado de Equipo:',
            data: this.details.equipmentStatus,
            cols: 'col-12 col-md pt-2',
          },
          {
            label: 'CAAT:',
            data: this.details.caat ?? '-',
            cols: 'col-12 col-md pt-2',
          },
          {
            label: 'Estatus:',
            statusColor: this.details.statusColor,
            statusName: this.details.statusName,
            cols: 'col-12 col-md pt-2',
          },
        ],
      ];
    },
    tabParam() {
      return this.$route.query.tab ? Number(this.$route.query.tab) : null;
    },
  },
  async mounted() {
    await this.initData();
    await this.getEquipmentBinnacles();
  },
  methods: {
    async initData() {
      await this.getEquipmentDetails();
      await this.getEquipmentLoanDetails();
      await this.getEquipmentLoanReturnDetails();
      if (this.tabParam) {
        this.setCurrentTab(this.tabParam);
      }
    },
    async getEquipmentDetails() {
      const { data } = await service.getEquipmentDetails(this.equipmentId);
      this.details = data;
    },
    async getEquipmentLoanDetails() {
      const { data } = await service.getEquipmentLoanDetails(this.equipmentId);
      this.loanInfo = data;
    },
    async getEquipmentBinnacles() {
      const { data } = await service.getEquipmentBinnaclesHistory(
        this.equipmentId
      );
      this.binnacles = data;
    },
    async getEquipmentLoanReturnDetails() {
      const { data } = await service.getEquipmentLoanReturnDetails(
        this.equipmentId
      );
      this.returnedLoanDetails = data;
    },
    setCurrentTab(tab) {
      this.activeTab = tab;
      if (tab) this.$router.replace({ query: { tab } });
      else this.$router.replace({ name: this.$route.name });
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .font-weight-bold {
  font-weight: 700 !important;
}
</style>
